// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';

export const parseHelpCenterAri = (helpCenterAri: string) => {
	const isValidAri =
		HelpHelpCenterAri.check(helpCenterAri) && helpCenterAri !== 'null' && helpCenterAri !== '';
	return isValidAri ? HelpHelpCenterAri.parse(helpCenterAri) : { helpCenterId: '' };
};

export const getHelpCenterId = (helpCenterAri: string) => {
	const { helpCenterId } = parseHelpCenterAri(helpCenterAri);
	return helpCenterId;
};

export const createHelpCenterAri = (activationId: string, helpCenterId: string) => {
	if (!helpCenterId || !activationId || helpCenterId === 'null' || activationId === 'null') {
		return '';
	}
	return HelpHelpCenterAri.create({ activationId, helpCenterId }).toString();
};
